import React, { useEffect } from "react";
import mobileicon from '../../assets/mobileicon.png'
import '../Paytm/paytm.css'
import { Box, Typography } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import {  IconButton} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import logger from "../../Utils/logger";
const Paytm=(props)=>{
  //logger.log("remainingTime",props.remainingTime)
  useEffect(()=>{
    window.scrollTo(0, 200); 
  },[])
  const navigate=useNavigate();
  const MyHeader = () => {
     
  const handleBack=()=>{
  
   logger.log("machineId")
    navigate(`/paymentOptions`)
  
  }
    return (
      <Box display="flex" alignItems="center" p={2} sx={{ background: "#fae14b" ,position: "fixed",width:"100%",zIndex: "999"}}>
        <Box display={"flex"} width={"100%"} alignItems={"center"}     justifyContent="space-between">
        <Box display={"flex"}>
        <IconButton onClick={handleBack}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 500, ml: 1 }}>
          Paytm
        </Typography>
        </Box>
       
        </Box>
      </Box>
    );
  };
    return(<>
    
     <MyHeader/>

 
        { props.mobileFlag&&
             <div>
             <div
               style={{
                 padding: "5%",
                 display: "flex",
                 "justify-content": "space-around",paddingTop:"100px"
                
               }}
             >
               <div>
                   <div style={{ "display":"flex","justify-content":"space-evenly"}}>
                 <img style={{ width: "170px", padding: "17%" }} src={mobileicon} />
                 </div>
                 <h3 style={{ "text-align":"center",color:"#333F4E",fontSize:"20px",fontWeight:"700"}}>Phone Verification</h3>
                 <p style={{textAlign:"center","margin-top":"7%",color:"#64748B",fontSize:"14px",fontWeight:"400"}}>Your verification code send to {props.mobile}</p>
               </div>
             </div>
   
             <div style={{ display: "flex", "justify-content": "space-evenly" }}>
               {" "}
               <input
                 style={{
                  /*  "text-align": "center", */
                   padding: "3%",
                   width: "81%",
                   "margin-bottom": "11%",
                   borderRadius: "11px",
                   "font-size": "21px",
                   border:" 1px solid rgb(148, 163, 184)"
                   
                 }}
                 onChange={(e)=>{props.onchangeOtp(e)}} 
                placeholder="OTP"
               />
             </div>
            {/*  <p style={{"fontSize":"13px",fontWeight:"400",textAlign:"center"}}>Didn’t receive code? Resend in 30s</p> */}
            <div style={{    display: "flex","margin-top":"12%","justify-content":"center"}}>
      <p >Didn’t receive code?{props.remainingTime>0?<span>Resend</span>:<span style={{color:"rgb(0, 177, 119)"}} onClick={props.handleSendOTP}>Resend</span>}</p>
     
      </div>
      {props.isDisabled&&<p style={{    display:"flex","justify-content":"center"}}><span>{props.remainingTime>0&&`${props.remainingTime}s`}</span></p>}
     <div style={{display:"flex","justify-content":"center", "margin-top":"44px"}}>
     
        
  
            </div> 
             <div style={{ display: "flex", "justify-content": "space-evenly", "margin-top":"5%" }}>
               {props.Otp.length==6?<button
                 className="btnEnable"
                 style={{ width: "81%" }}
                 onClick={props.Verfy}
               >
                 <p style={{ "font-size": "21px" }}>Verify</p>
   
               </button>: <button
                 className="btnEnable"
                 style={{ width: "81%",backgroundColor:"#808780" }}
                
               >
                 <p style={{ "font-size": "21px" }}>Verify</p>
   
               </button>
               }


             </div>
           </div>
   
        }

    
    
    </>)
}
export default Paytm